export default __webpack_public_path__ + "static/media/clock.6db046a6.svg";